import { AppThemingContainer } from "@trinity/chat-components/containers/AppTheming/AppThemingContainer.js";
import { AppThemingHelmet, FetchAppThemingProvider } from "./AppThemingContainer";
import { FetchBrandingProvider } from './BrandingContainer';

const AppThemingProvider = (props: { children: React.ReactNode }) => {
  return (
    <FetchBrandingProvider>
      <FetchAppThemingProvider>
        <AppThemingContainer>
          <AppThemingHelmet>
            {props.children}
          </AppThemingHelmet>
        </AppThemingContainer>
      </FetchAppThemingProvider>
    </FetchBrandingProvider>
  );
};
export { AppThemingProvider as AppThemingContainer };